// TODO Have to be refactored and properly tested.
/* istanbul ignore next */
export function TypeExtends() {
    if (typeof Date.prototype.formatDate === "undefined") {
        /**
        * Returns formatted date
        *
        * @param {number} format Format for output
        */
        Date.prototype.formatDate = function (format) {
            let res = format;
            res = res.replace(/YYYY/i, this.getFullYear().formatNum("0000"));
            res = res.replace(/YY/i, (this.getFullYear() % 100).formatNum("00"));
            res = res.replace(/Y/i, (this.getFullYear() % 100).toString());
            res = res.replace(/dd/, (this.getDate()).formatNum("00"));
            res = res.replace(/d/, this.getDate().toString());
            res = res.replace(/K+/, (this.getTimezoneOffset() < 0 ? "+" : "-") + (Math.abs(this.getTimezoneOffset()) / 60).toFixed() + (Math.abs(this.getTimezoneOffset()) % 60).toStringEx("00"));
            res = res.replace(/hh/, this.getHours() === 12 ? "12" : (this.getHours() % 12).formatNum("00"));
            if (res.match(/\st/)) {
                res = res.replace(/h/, this.getHours() === 0 || this.getHours() === 12 ? "12" : (this.getHours() % 12).toString());
            }
            else {
                res = res.replace(/h/, this.getHours() === 12 ? "12" : (this.getHours() % 12).toString());
            }
            res = res.replace(/HH/, this.getHours().formatNum("00"));
            res = res.replace(/H+/, this.getHours().toString());
            res = res.replace(/m{2,}/, this.getMinutes().formatNum("00"));
            res = res.replace(/m/, this.getMinutes().toString());
            res = res.replace(/s{2,}/, this.getSeconds().formatNum("00"));
            res = res.replace(/s/, this.getSeconds().toString());
            res = res.replace(/MM/, (this.getMonth() + 1).formatNum("00"));
            res = res.replace(/\st/, this.getHours() < 12 ? " AM" : " PM");
            res = res.replace(/ff(f+)/, this.getMilliseconds().toStringEx("000"));
            res = res.replace(/ff/, this.getMilliseconds().toStringEx("00"));
            return res;
        };
    }
    if (typeof Date.prototype.formatDateUTC === "undefined") {
        /**
        * Returns formatted UTC date
        *
        * @param {number} format Format for output
        */
        Date.prototype.formatDateUTC = function (format) {
            let res = format;
            res = res.replace(/YYYY/i, this.getUTCFullYear().formatNum("0000"));
            res = res.replace(/YY/i, (this.getUTCFullYear() % 100).formatNum("00"));
            res = res.replace(/Y/i, (this.getUTCFullYear() % 100).toString());
            res = res.replace(/dd/, (this.getUTCDate()).formatNum("00"));
            res = res.replace(/d/, this.getUTCDate().toString());
            res = res.replace(/K+/, (this.getTimezoneOffset() < 0 ? "+" : "-") + (Math.abs(this.getTimezoneOffset()) / 60).toFixed() + (Math.abs(this.getTimezoneOffset()) % 60).toStringEx("00"));
            res = res.replace(/Z+/, "UTC");
            res = res.replace(/hh/, this.getUTCHours() === 12 ? "12" : (this.getHours() % 12).formatNum("00"));
            if (res.match(/\st/)) {
                res = res.replace(/h/, this.getUTCHours() === 0 || this.getUTCHours() === 12 ? "12" : (this.getHours() % 12).toString());
            }
            else {
                res = res.replace(/h/, this.getUTCHours() === 12 ? "12" : (this.getHours() % 12).toString());
            }
            res = res.replace(/HH/, this.getUTCHours().formatNum("00"));
            res = res.replace(/H+/, this.getUTCHours().toString());
            res = res.replace(/m{2,}/, this.getUTCMinutes().formatNum("00"));
            res = res.replace(/m/, this.getUTCMinutes().toString());
            res = res.replace(/s{2,}/, this.getSeconds().formatNum("00"));
            res = res.replace(/s/, this.getSeconds().toString());
            res = res.replace(/MM/, (this.getUTCMonth() + 1).formatNum("00"));
            res = res.replace(/\st/, this.getUTCHours() < 12 ? " AM" : " PM");
            res = res.replace(/ff(f+)/, this.getMilliseconds().toStringEx("000"));
            res = res.replace(/ff/, this.getMilliseconds().toStringEx("00"));
            return res;
        };
    }
    if (typeof Date.prototype.toStringEx === "undefined") {
        /**
         * Date and time formating functions. Not all formats were realized.
         *
         * @param {number} format Format for output
         */
        Date.prototype.toStringEx = function (format) {
            let res = format;
            if (res.match(/Z/) || res.match(/UTC/)) {
                res = this.formatDateUTC(res);
            }
            else {
                res = this.formatDate(res);
            }
            return res;
        };
    }
    if (typeof Date.prototype.isDaylightSavingTimeInUK === "undefined") {
        Date.prototype.isDaylightSavingTimeInUK = function () {
            // Start of daylight saving time in UK is at 1am on the last sunday of March
            let startOfDST = new Date(this.getFullYear(), 2, 31);
            startOfDST.setDate(startOfDST.getDate() - startOfDST.getDay());
            startOfDST.setHours(1);
            // End of daylight saving time in UK is at 2am on the last sunday of October
            let endOfDST = new Date(this.getFullYear(), 9, 31);
            endOfDST.setDate(endOfDST.getDate() - endOfDST.getDay());
            endOfDST.setHours(2);
            return this.valueOf() >= startOfDST.valueOf() && this.valueOf() < endOfDST.valueOf();
        };
    }
    if (typeof Number.prototype.formatNum === "undefined") {
        Number.prototype.formatNum = function (format) {
            let rformat = "";
            let fformat = "";
            if (format.indexOf(".") > 0) {
                let zzz = format.split(".");
                rformat = zzz[0];
                fformat = zzz[1];
            }
            else if (format.indexOf(",") > 0) {
                let zzz = format.split(",");
                rformat = zzz[0];
                fformat = zzz[1];
            }
            else {
                rformat = format;
                fformat = "";
            }
            if (fformat.match(/0+#+/)) {
                let r = fformat.match(/(0+)/);
                let ll = r && r[0].length;
                let zz = this.formatNum(`${rformat}.${fformat.replace("#", "0")}`);
                let splitter = zz.match(new RegExp("\\.(\\d{" + ll + "})(\\d+)$"));
                let new_part = "";
                if (splitter) {
                    new_part = `${splitter[1]}${splitter[2].replace(/0+$/, "")}`;
                }
                return zz.replace(/\d+$/, new_part);
            }
            if (rformat.match(/#+/) && fformat.match(/0+/)) {
                return this.toFixed(fformat.length);
            }
            if (rformat.match(/#+/) && fformat.match(/#*/)) {
                return this.toFixed(fformat.length).replace(/0+$/, "").replace(/\.$/, "");
            }
            if (rformat.match(/0+/) && fformat.match(/0+/)) {
                let zz = this.toFixed(fformat.length);
                while (zz.length < rformat.length + fformat.length + (fformat ? 1 : 0)) {
                    zz = "0" + zz;
                }
                return zz;
            }
            if (rformat.match(/0+/) && fformat.match(/#*/)) {
                let pow = Math.pow(10, fformat.length);
                let zz1 = ((Math.floor(this.valueOf() * (pow))) / (pow)).toFixed(fformat.length);
                while (zz1.length < rformat.length + fformat.length + (fformat ? 1 : 0)) {
                    zz1 = "0" + zz1;
                }
                if (fformat) {
                    return zz1.replace(/0+$/, "").replace(/\.$/, "");
                }
                else {
                    return zz1;
                }
            }
            return this.valueOf().toString();
        };
    }
    if (typeof Number.prototype.roundToDigit === "undefined") {
        /**
         * Used to round digits more precisely after the decimal point
         *
         * @param {number} decimal Precision for rounding
         */
        Number.prototype.roundToDigit = function (decimal) {
            let firstPart = Math.round(Number(`${this.valueOf()}e${decimal}`));
            let secondPart = Number(`e-${decimal}`);
            return Number(firstPart + secondPart);
        };
    }
    if (typeof Number.prototype.toStringEx === "undefined") {
        /**
         * Formating function for Numbers. Can take formats:
         *  G - general
         *  E - Exponential (with n digints in second case)
         *  And custom format with marked digit places 0 (for obligatory digits)  or # (for possible digits)
         *
         * @param {string} format Format for output
         */
        Number.prototype.toStringEx = function (format) {
            let sign = "";
            // scientific formats
            if (format === "G") {
                return this.toString();
            }
            if (format === "E") {
                return this.toExponential();
            }
            if (format.match(/E(\d+)/)) {
                return this.toExponential(parseInt(RegExp.$1));
            }
            if (format.match(/S(.+)/)) {
                sign = this.valueOf() > 0 ? "+" : "";
                let zformat = RegExp.$1;
                if (zformat.indexOf(".") < 0) {
                    return sign + this.toStringEx(zformat);
                }
                let zzz = format.split(".");
                let ddl = 1;
                for (let i = 0; i < zzz[1].length; i++) {
                    ddl *= 10;
                }
                return sign + (Math.floor(this.valueOf() * ddl) / ddl).toStringEx(zformat);
            }
            // custom format : with 0 and #
            let rformat = ""; // round part of format
            let fformat = ""; //
            if (format.indexOf(".") > 0) {
                let zzz = format.split(".");
                rformat = zzz[0];
                fformat = zzz[1];
            }
            else if (format.indexOf(",") > 0) {
                let zzz = format.split(",");
                sign = ",";
                rformat = zzz[0];
                fformat = zzz[1];
            }
            else {
                rformat = format;
                fformat = "";
            }
            if (fformat.match(/0+#+/)) {
                let r = fformat.match(/(0+)/);
                let ll = r && r[0].length;
                let zz = this.toStringEx(rformat + "." + fformat.replace("#", "0"));
                let splitter = zz.match(new RegExp("\\.(\\d{" + ll + "})(\\d+)$"));
                let new_part = "";
                if (splitter !== null) {
                    new_part = splitter[1] + splitter[2].replace(/0+$/, "");
                }
                return zz.replace(/\d+$/, new_part);
            }
            if (rformat.match(/0+/) && fformat.match(/0+#+/)) {
                let r = fformat.match(/(0+)/);
                let ll = r && r[0].length;
                let zz = this.toFixed(fformat.length);
                let splitter = zz.match(new RegExp("\\.(\\d{" + ll + "})(\\d+)$"));
                let new_part = "";
                if (splitter !== null) {
                    new_part = splitter[1] + splitter[2].replace(/0+$/, "");
                }
                return zz.replace(/\d+$/, new_part);
            }
            if (rformat.match(/#+ #+0+/)) {
                let formattedString = this.toLocaleString("cs");
                //if this is integer we have to add as much 0, as the formatter matches
                if (fformat.match(/0+/) && this.valueOf() !== 0 && this.valueOf() % 1 === 0) {
                    formattedString = formattedString + "," + Array(fformat.length + 1).join("0");
                }
                //if this have one number after the decimal separator, we have to add one less 0
                else if (fformat.match(/0+/) && this.valueOf() !== 0 && (fformat.length > 1) && ((this.valueOf() * 10) % 1 === 0)) {
                    formattedString = formattedString + Array(fformat.length).join("0");
                }
                return formattedString;
            }
            if (rformat.match(/#+/) && fformat.match(/0+/)) {
                return this.toFixed(fformat.length);
            }
            if (rformat.match(/#+/) && fformat.match(/#*/)) {
                return this.toFixed(fformat.length).replace(/0+$/, "").replace(/\.$/, "");
            }
            if (rformat.match(/0+/) && fformat.match(/0+/)) {
                let zz = this.toFixed(fformat.length);
                while (zz.length < rformat.length + fformat.length + (fformat ? 1 : 0)) {
                    zz = "0" + zz;
                }
                return zz;
            }
            if (rformat.match(/0+/) && fformat.match(/#*/)) {
                // let pow = Math.pow(10, fformat.length);
                // When multyplying * pow sometimes we get values that are like 13215.9999999999997 and after Math.floor we are loosing precision,
                // so using roundToDigit for more accurate precision
                // let zz = ((Math.floor(this.multiply(pow))).divide(pow)).toFixed(fformat.length);
                let zz = this.roundToDigit(fformat.length).toFixed(fformat.length);
                while (zz.length < rformat.length + fformat.length + (fformat ? 1 : 0)) {
                    zz = "0" + zz;
                }
                if (fformat) {
                    return zz.replace(/0+$/, "").replace(/\.$/, "");
                }
                else {
                    return zz;
                }
            }
            throw "Bad format string";
        };
    }
    if (typeof String.prototype.toStringEx === "undefined") {
        String.prototype.toStringEx = function (format) {
            return this.toString();
        };
    }
    if (typeof String.prototype.format === "undefined") {
        /**
         * С#-like formating function.
         * Usage : "{0} ... {1} ... {2}".format(1,2,3);
         *
         * @param {(string | number | Date)[]} params Values to be put in string
         */
        String.prototype.format = function (...params) {
            let xx = this + "";
            let rex = /\{(\d+):?(.*?)\}/igm;
            let formatter = {
                context: params,
                callback: (expr, index, format) => {
                    index = parseInt(index);
                    if (isNaN(index)) {
                        return expr;
                    }
                    let params = formatter.context;
                    if ((!params) || (params.length <= index)) {
                        return expr;
                    }
                    let val = params[index];
                    if ((format) && (val != undefined) && (val != undefined) && (val.toStringEx)) {
                        return val.toStringEx(format);
                    }
                    return val || val === 0 ? val.toString() : "";
                }
            };
            return xx.replace(rex, formatter.callback);
        };
    }
    if (typeof String.prototype.toLocalizedNumberString === "undefined") {
        String.prototype.toLocalizedNumberString = function (format) {
            var result = "";
            if (isNaN(this) || this.length === 0 || typeof (format) === "undefined" || !format) {
                result = this;
            }
            else {
                result = this.toLocalizedNumberStringChecked(format);
            }
            return result.toString();
        };
    }
    if (typeof String.prototype.toLocalizedNumberStringChecked === "undefined") {
        String.prototype.toLocalizedNumberStringChecked = function (format) {
            if (this.indexOf(".") < 0) {
                return Number(this).toLocaleString(format);
            }
            else {
                return this.toLocalizedDecimalNumberString(format);
            }
        };
    }
    if (typeof String.prototype.toLocalizedDecimalNumberString === "undefined") {
        String.prototype.toLocalizedDecimalNumberString = function (format) {
            var decimalPart = this.substr(this.indexOf("."));
            var localizedString = Number(this).toLocaleString(format);
            if (localizedString.indexOf(decimalPart) < 0) {
                var newDecimalPartIndex = localizedString.indexOf(".");
                if (newDecimalPartIndex >= 0) {
                    var newDecimalPart = localizedString.substr(newDecimalPartIndex);
                    decimalPart = decimalPart.replace(newDecimalPart, "");
                }
                return localizedString + decimalPart;
            }
            return localizedString;
        };
    }
}
//# sourceMappingURL=TypeExtends.js.map